import React from "react";
import { isPdf, isVideo } from "../../utils";
import ModalDialog from "./ModalDialog";
import styles from "./PreviewFileDialog.module.css";

type Props = {
  docUrl?: string;
  fileName: string;
  onClose: () => void;
};

const PreviewFileDialog: React.FC<Props> = ({ docUrl, fileName, onClose }) => {
  if (!docUrl) return null;

  const fileIsPdf = isPdf(fileName);

  return (
    <ModalDialog full={fileIsPdf} onClose={onClose} title={fileName}>
      {fileIsPdf ? (
        <div className={styles.embedDoc}>
          <object data={docUrl} type="application/pdf" width="100%" height="100%">
            <iframe src={docUrl} width="100%" height="100%" title={fileName}></iframe>
          </object>
        </div>
      ) : isVideo(fileName) ? (
        <video src={docUrl} controls style={{ maxWidth: "100%" }} />
      ) : (
        <img src={docUrl} alt={fileName} style={{ maxWidth: "100%" }} />
      )}
    </ModalDialog>
  );
};

export default PreviewFileDialog;
